import { render, staticRenderFns } from "./ProfileSync.vue?vue&type=template&id=0d29deba&"
import script from "./ProfileSync.vue?vue&type=script&lang=js&"
export * from "./ProfileSync.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSync.vue?vue&type=style&index=0&id=0d29deba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports